import * as THREE from "three"


import Experience from "../Experience"
import backgroundFragmentShader from "../shaders/background/backgroundFragment.glsl"
import backgroundVertexShader from "../shaders/background/backgroundVertex.glsl"

export default class Background {

    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.time = this.experience.time


        // Setup
        this.setup()
    }


    setup() {
        this.colorA = "#b0b0b0" // Made this much darker!
        this.colorB = "#151937"

        this.material = new THREE.ShaderMaterial({
            vertexShader: backgroundVertexShader,
            fragmentShader: backgroundFragmentShader,
            uniforms: {
                uColorA: { value: new THREE.Color(this.colorA) },
                uColorB: { value: new THREE.Color(this.colorB) },
                uTime: { value: 0 },
                uAspect: { value: this.experience.sizes.width / this.experience.sizes.height }
            }
        })

        const plane = new THREE.Mesh(
            new THREE.PlaneGeometry(2, 2, 1, 1),
            this.material
        )
        plane.material.depthTest = false
        plane.material.depthWrite = false
        plane.frustumCulled = false
        this.scene.add(plane)

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.gui.addFolder("Background")

            this.debugFolder.addColor(this, "colorA").name("Color A").onChange(() => {
                this.material.uniforms.uColorA.value.set(this.colorA)
            })

            this.debugFolder.addColor(this, "colorB").name("Color B").onChange(() => {
                this.material.uniforms.uColorB.value.set(this.colorB)
            })
        }
    }

    update() {
        if (this.material) {
            this.material.uniforms.uTime.value = this.time.elapsedTime
            this.material.uniforms.uAspect.value = this.experience.sizes.width / this.experience.sizes.height
        }
    }
}